import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import 'hammerjs';

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { AppComponent } from 'app/app.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { InternalServerErrorComponent } from './errors/internal-server-error/internal-server-error.component';
import { UnauthorizedComponent } from './errors/unauthorized/unauthorized.component';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./trendit-apps/trendit-apps.module').then(m=>m.TrenditAppsModule),
    title: 'TREND-IT Apps'
  },
  {
      path: 'server-error',
      component: InternalServerErrorComponent
  },
  {
      path: 'unauthorized',
      component: UnauthorizedComponent
  },
  {
    path: '**',
    component: NotFoundComponent,
    title : 'Not Found'
  }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
      CoreModule,
      CoreCommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', 
      relativeLinkResolution: 'legacy'
    }),
  ],

  bootstrap: [AppComponent]
})
export class AppModule {}
